import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // A tag <React.StrictMode> foi removida para resolver o erro.
  <App />
);

// Se você quiser começar a medir o desempenho em seu aplicativo, passe uma função
// para registrar os resultados (por exemplo: reportWebVitals(console.log))
// ou envie para um ponto de extremidade de análise. Saiba mais: https://bit.ly/CRA-vitals
reportWebVitals();